import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { useI18n, ROLE_LABELS } from "../../i18n";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";

export default function TimeReport() {
  const { t, lang, pick } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/time-report").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-muted-foreground">{t("loading")}</div>;

  const svc = (r) => (lang === "ar" ? r.service_label_ar : r.service_label_en);

  const exportCsv = () => {
    const header = ["Consultant", "Role", "Client", "Service", "Cases", "Hours"];
    const lines = data.rows.map((r) => [r.consultant, r.role, r.organization_name, svc(r), r.cases, r.hours]);
    const csv = [header, ...lines]
      .map((a) => a.map((x) => `"${String(x ?? "").replace(/"/g, '""')}"`).join(","))
      .join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "vatradar-time-report.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-5 gc-fade-up">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("time_report_title")}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t("total_hours")}: <b className="text-foreground">{data.total_hours} {t("hours")}</b></p>
        </div>
        <Button data-testid="export-csv-btn" onClick={exportCsv} className="rounded-full bg-[hsl(217_63%_15%)] hover:bg-[hsl(217_63%_20%)]">
          <Download className="me-2 h-4 w-4" /> {t("export_csv")}
        </Button>
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
            <th className="text-start px-4 py-3 font-medium">{t("consultant")}</th>
            <th className="text-start px-4 py-3 font-medium hidden sm:table-cell">{t("role")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("nav_clients")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("service")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("assigned_cases")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("hours_worked")}</th>
          </tr></thead>
          <tbody>
            {data.rows.length === 0 && <tr><td colSpan={6} className="px-4 py-6 text-center text-muted-foreground">{t("no_data")}</td></tr>}
            {data.rows.map((r, i) => (
              <tr key={i} data-testid={`time-report-row-${i}`} className="border-t border-border hover:bg-secondary/40">
                <td className="px-4 py-3 font-medium">{r.consultant}</td>
                <td className="px-4 py-3 text-muted-foreground hidden sm:table-cell">{pick(ROLE_LABELS[r.role] || { en: r.role, ar: r.role })}</td>
                <td className="px-4 py-3">{r.organization_name}</td>
                <td className="px-4 py-3">{svc(r)}</td>
                <td className="px-4 py-3 font-mono">{r.cases}</td>
                <td className="px-4 py-3 font-mono font-bold text-[hsl(158_64%_28%)]">{r.hours} {t("hours")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
